document.addEventListener('variant:change', () => {
    setTimeout(() => {
        if(!window.aco_appMeta) return
        const selector = window.aco_appMeta?.strings?.product_top_price_selector || '';
        const priceTextElem = selector ? document.querySelector(selector) : null;

        const priceElem = document.querySelector('#aco_price_hidden');
        if (!priceElem?.value) return;

        const priceData = JSON.parse(priceElem.value);
        // console.log("priceData ==> ", priceData)
        const price = priceData?.total;

        // You can use the `price` variable here
        // console.log("priceTextElem ==> ", priceTextElem)
        let format = 
            (window.aco_appMeta?.change_price_summary_format && window.aco_appMeta?.custom_price_summary_format)
            ? window.aco_appMeta.custom_price_summary_format 
            : window.aco_shopCurrencyFormat;
        const data = formatMoney(price * 100, format);
        // console.log("data ==> ", data)
        if(priceTextElem) priceTextElem.innerHTML = data;
    }, 1000)
});

/**
 * Function to format money by using current stores money format
 *
 * @param {number} money Money to format
 * @param {string} type Whether it is a line price or total price
 * @returns
 */
const formatMoney = (cents, format) => {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  // var formatString = format || this.money_format;
  let formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

